module.exports = __webpack_public_path__ + "img/analyst.2ad9346c.png";